export default function PHP_time() {
  return (
    <div>
      <h1>PHP_time</h1>
    </div>
  );
}
